import { createApp } from 'vue'
import { createVfm } from 'vue-final-modal'
import 'vue-final-modal/style.css'

import ModalsApp from './apps/ModalsApp.vue'

import settingsMixinVue from '@mixins/settingsMixin.vue'

// Import all possible modal components in this section.
import BulkActionModal from '@modals/BulkActionModal.vue'
import GoogleMapsModal from '@modals/GoogleMapsModal.vue'
import InteractiveMapModal from '@modals/InteractiveMapModal.vue'
import TargetAreaModal from '@modals/TargetAreaModal.vue'
import TrainingCenterStateModal from '@modals/TrainingCenterStateModal.vue'
import ReportingEntityModal from '@modals/ReportingEntityModal.vue'
import DropTimothyModal from '@modals/DropTimothyModal.vue'
import DropChurchModal from '@modals/DropChurchModal.vue'
import FieldRepVisitModal from '@modals/FieldRepVisitModal.vue'
import VersionChangesModal from '@modals/VersionChangesModal.vue'
import ChurchVillageModal from '@modals/ChurchVillageModal.vue'
import siloSetupModal from '@modals/siloSetupModal.vue'
import GenericInfoModal from '@modals/GenericInfoModal.vue'
import GenericListModal from '@modals/GenericListModal.vue'
import IframeModal from '@modals/IframeModal.vue'
import PersonLinkageModal from '@modals/PersonLinkageModal.vue'
import FormsChurchCreationModal from '@modals/FormsChurchCreationModal.vue'
import issueSettingsModal from '@modals/issueSettingsModal.vue'
import DuplicateVisitWarning from '@modals/DuplicateVisitWarning.vue'
import VillageSurveyModal from '@modals/VillageSurveyModal.vue'
import FileModal from "@modals/FileModal.vue"
import PersonRoleCreationModal from '@modals/PersonRoleCreationModal.vue'
import StandardizedLocationModal from '@modals/StandardizedLocationModal.vue'
import FindMissingRelatableModal from '@modals/FindMissingRelatableModal.vue'
import RecordInfoModal from '@modals/RecordInfoModal.vue'

import { GoogleMap, Marker, InfoWindow, MarkerCluster } from 'vue3-google-map'

// Store modals app instance for cleanup before Turbo navigation (prevents "nextSibling of null" error)
let modalsVueAppInstance = null

function unmountModalsApp() {
  if (modalsVueAppInstance) {
    try {
      modalsVueAppInstance.unmount()
    } catch (_e) {
      // App may already be unmounted
    }
    modalsVueAppInstance = null
  }
}

// Unmount before Turbo replaces the page so Vue can clean up while DOM nodes still exist
document.addEventListener('turbo:visit', unmountModalsApp)

document.addEventListener('turbo:load', () => {
  const container = document.querySelector('#modals-vue-target')
  if (!container) return

  // Unmount any existing app first (handles double-mount when turbo:load fires multiple times)
  if (container.__vue_app__) {
    container.__vue_app__.unmount()
  }
  unmountModalsApp()

  const modalsVueApp = createApp(ModalsApp)

  modalsVueApp.provide('apiKey', window.gon.googleMapsApiKey)

  // Add rollbar usage to modals app
  modalsVueApp.config.globalProperties.$rollbar = window.Rollbar
  modalsVueApp.config.errorHandler = (err, vm, info) => {
    window.Rollbar.error(err, info)
    throw err
  }

  // apply vue-final-modal to the modals app
  const vfm = createVfm()
  modalsVueApp.use(vfm)

  modalsVueApp.mixin(settingsMixinVue)

  modalsVueApp.component('GoogleMap', GoogleMap)
  modalsVueApp.component('Marker', Marker)
  modalsVueApp.component('InfoWindow', InfoWindow)
  modalsVueApp.component('MarkerCluster', MarkerCluster)

  // Register all modals onto the modals Vue app
  modalsVueApp.component('BulkActionModal', BulkActionModal)
  modalsVueApp.component('GoogleMapsModal', GoogleMapsModal)
  modalsVueApp.component('InteractiveMapModal', InteractiveMapModal)
  modalsVueApp.component('TargetAreaModal', TargetAreaModal)
  modalsVueApp.component('TrainingCenterStateModal', TrainingCenterStateModal)
  modalsVueApp.component('ReportingEntityModal', ReportingEntityModal)
  modalsVueApp.component('DropTimothyModal', DropTimothyModal)
  modalsVueApp.component('DropChurchModal', DropChurchModal)
  modalsVueApp.component('FieldRepVisitModal', FieldRepVisitModal)
  modalsVueApp.component('VersionChangesModal', VersionChangesModal)
  modalsVueApp.component('ChurchVillageModal', ChurchVillageModal)
  modalsVueApp.component('siloSetupModal', siloSetupModal)
  modalsVueApp.component('GenericInfoModal', GenericInfoModal)
  modalsVueApp.component('GenericListModal', GenericListModal)
  modalsVueApp.component('IframeModal', IframeModal)
  modalsVueApp.component('PersonLinkageModal', PersonLinkageModal)
  modalsVueApp.component('FormsChurchCreationModal', FormsChurchCreationModal)
  modalsVueApp.component('issueSettingsModal', issueSettingsModal)
  modalsVueApp.component('DuplicateVisitWarning', DuplicateVisitWarning)
  modalsVueApp.component("FileModal", FileModal)
  modalsVueApp.component('VillageSurveyModal', VillageSurveyModal)
  modalsVueApp.component('PersonRoleCreationModal', PersonRoleCreationModal)
  modalsVueApp.component('StandardizedLocationModal', StandardizedLocationModal)
  modalsVueApp.component('FindMissingRelatableModal', FindMissingRelatableModal)
  modalsVueApp.component('RecordInfoModal', RecordInfoModal)

  modalsVueApp.mount(container)
  modalsVueAppInstance = modalsVueApp
})